<p-confirmDialog
  [header]="'Conf' | translate"
  [icon]="icon"
  [key]="key"
  [styleClass]="severity + ' font-size-14'"
  [closable]="false"
  [style]="{width: '25vw'}"
  #cd
  [baseZIndex]="10000"
  appendTo="body"
>
  <ng-template pTemplate="footer">
    <button class="p-button-primary p-button-outlined" pButton label="{{'Cancel' | translate}}" (click)="cd.reject()"></button>
    <button pButton label="{{'Valid' | translate}}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>

